<template>
  <section class="event-slider">
    <div class="container-2">
      <h2 class="font-34">
        {{ _.get(contentData, 'conf.header.title') || $fn.tr('Other Events') }}
      </h2>

      <div class="relative">
        <swiper ref="myEventsSlider" class="swiper-view" :options="swiperOptions">
          <template v-for="(item, index) in _.get(contentData, 'data.list')">
            <swiper-slide v-if="currentPageId !== item.id" class="single-slide" :key="index">
              <SliderCard :data="item" />
            </swiper-slide>
          </template>
        </swiper>
        <div class="swiper-prev">
          <IconComponent name="slider-next" />
        </div>
        <div class="swiper-next">
          <IconComponent name="slider-next" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SliderCard from '../cards/EventSliderCard.vue';
import IconComponent from '../IconComponent.vue';

export default {
  props: ['contentData'],

  components: {
    SliderCard,
    IconComponent,
  },

  data() {
    return {
      swiperOptions: {
        speed: 800,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev',
        },
        breakpoints: {
          320: {
            spaceBetween: 15,
            slidesPerView: 1.3,
          },
          768: {
            spaceBetween: 15,
            slidesPerView: 1.3,
          },
          1024: {
            spaceBetween: 30,
            slidesPerView: 2,
          },
          1366: {
            spaceBetween: 30,
            slidesPerView: 3,
          },
        },
      },
    };
  },
  computed: {
    currentPageId() {
      return _.get(this.$store.state.main.current_content, 'primary.data.list[0].id');
    },
  },
};
</script>

<style lang="scss">
.event-slider {
  margin: 55px 0;
  h2 {
    margin-bottom: 34px;
    width: fit-content;
    color: var(--bonus-txt);
    @media (max-width: 767px) {
      padding: 0 20px;
      font-size: 21px;
    }
  }
  .relative {
    position: relative;
    .swiper-container {
      overflow: visible;
    }
    .swiper-next {
      position: absolute;
      top: 35%;
      right: -85px;
      z-index: 3;
      width: 60px;
      height: 35px;
      transform: translateY(-50%);
      background: var(--primary);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      @media (max-width: 1700px) and (min-width: 1500px) {
        right: 40px;
      }
      @media (max-width: 1023px) {
        display: none;
      }
    }
    .swiper-prev {
      position: absolute;
      top: 35%;
      left: -85px;
      z-index: 3;
      width: 60px;
      height: 35px;
      transform: translateY(-50%);
      background: var(--primary);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      @media (max-width: 1700px) and (min-width: 1500px) {
        left: 40px;
      }
      @media (max-width: 1023px) {
        display: none;
      }
      svg {
        transform: rotate(180deg);
      }
    }
    .swiper-slide {
      height: auto;
    }
    .swiper-button-disabled {
      opacity: 0;
      pointer-events: none;
    }
    .swiper-slide-active {
      opacity: 1;
      transition: 0.4s ease-in-out;
    }
  }
}
</style>
